import { callDecimal } from "../utils.ts";

export interface TocEntry {
  title: string;
  level: number;
  page: string;
}

export function getTableOfContents(vbid: string) {
  return callDecimal<{ items: TocEntry[] }>(
    `/api/v1/products/${vbid}/table_of_content`
  );
}
